import Model from '@/lib/data/Model';

class FormQuestionHelpDocument extends Model {
    static idProperty = 'id';

    fields = ['id', 'form_ques_id', 'file_storage_id', 'mime_type', 'name'];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [];
}

export default FormQuestionHelpDocument;
